import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { getUserCountryCodeFromState } from 'selectors/app-selector';
import { serviceTypesInCitySelector } from 'selectors/booking-selectors';

import TaxiTypeTnc from './index';

const AnytimeBookingTaxiTypeTnc = ({
  className,
  delivery,
  countryCode,
  allTaxiTypes,
}) => {
  if (countryCode !== 'VN' || !allTaxiTypes) {
    return null;
  }

  const serviceType = _get(delivery, [
    'detail',
    'configuration',
    'serviceType',
  ]);
  if (!serviceType) {
    return null;
  }

  const taxiTypeID = _get(delivery, ['quote', 'taxiTypeID']);
  const taxiType = allTaxiTypes.find(tt => tt.ID === taxiTypeID);
  if (!taxiType) {
    return null;
  }

  return <TaxiTypeTnc className={className} serviceType={taxiType} />;
};

AnytimeBookingTaxiTypeTnc.defaultProps = {
  className: undefined,
  countryCode: undefined,
  allTaxiTypes: undefined,
};

AnytimeBookingTaxiTypeTnc.propTypes = {
  className: PropTypes.string,
  delivery: NewBookingDeliveryPropType.isRequired,
  countryCode: PropTypes.string,
  allTaxiTypes: PropTypes.arrayOf(PropTypes.shape({})),
};

export default connect(state => ({
  countryCode: getUserCountryCodeFromState(state),
  allTaxiTypes: serviceTypesInCitySelector(state),
}))(AnytimeBookingTaxiTypeTnc);
